import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {ToolsService} from '../../services/tools.service';
import {SeoMetaService} from '../../services/seo-meta.service';
import {MetaTag} from '../../types/MetaTag';
import {RoutesEnums} from '../../enums/RoutesEnums';
import {LinkService} from '../../services/link.service';
import {MetaTypesEnum} from '../../enums/SeoEnums';
import {AppConfigService} from '../../services/app-config.service';
import {SearchService} from '../../services/search/search.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundComponent implements OnInit {
  constructor(
    private tools: ToolsService,
    private metaService: SeoMetaService,
    private linkService: LinkService,
    private appConfigService: AppConfigService,
    private searchService: SearchService,
  ) {}

  ngOnInit() {
    this.searchService.softResetState();
    this.updateMetaTags();
    this.tools.scrollTo('page-title');
  }

  private updateMetaTags(): void {
    const metaTags: MetaTag[] = [];
    metaTags.push({
      value: 'noindex,nofollow',
      type: MetaTypesEnum.NAME,
      field: 'robots',
    });
    metaTags.push({
      value: 'Sidan kunde inte hittas',
      type: 'title',
      field: 'title',
    });
    metaTags.push({
      value: '404',
      type: 'name',
      field: 'prerender-status-code',
    });
    this.metaService.updateMetaTags(metaTags);

    const url = `${this.appConfigService.appConfig.baseUrl}${RoutesEnums.NOTFOUND}`;
    this.linkService.removeTag({rel: 'canonical'});
    this.linkService.updateTag({
      rel: 'canonical',
      href: url,
    });
  }
}
